exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._13poaNuZMDEbBLkuiXD8q9{color:\"[theme:neutralPrimary, default:#333333]\";font-size:12px;white-space:nowrap}html[dir] ._13poaNuZMDEbBLkuiXD8q9{padding:10px 0 4px;text-align:center}", ""]);

// exports
exports.locals = {
	"timeZonePanel": "_13poaNuZMDEbBLkuiXD8q9"
};